import "./index.css";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module !== "undefined" && module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames2;
        });
      } else {
        window.classNames = classNames2;
      }
    })();
  }
});

// src/MarkdownRenderer/MarkdownRenderer.tsx
import * as React2 from "react";
import Box3 from "@cloudscape-design/components/box";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

// ../../node_modules/@ungap/structured-clone/esm/types.js
var VOID = -1;
var PRIMITIVE = 0;
var ARRAY = 1;
var OBJECT = 2;
var DATE = 3;
var REGEXP = 4;
var MAP = 5;
var SET = 6;
var ERROR = 7;
var BIGINT = 8;

// ../../node_modules/@ungap/structured-clone/esm/deserialize.js
var env = typeof self === "object" ? self : globalThis;
var deserializer = ($, _) => {
  const as = (out, index) => {
    $.set(index, out);
    return out;
  };
  const unpair = (index) => {
    if ($.has(index))
      return $.get(index);
    const [type, value] = _[index];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY: {
        const arr = as([], index);
        for (const index2 of value)
          arr.push(unpair(index2));
        return arr;
      }
      case OBJECT: {
        const object = as({}, index);
        for (const [key, index2] of value)
          object[unpair(key)] = unpair(index2);
        return object;
      }
      case DATE:
        return as(new Date(value), index);
      case REGEXP: {
        const { source, flags } = value;
        return as(new RegExp(source, flags), index);
      }
      case MAP: {
        const map = as(/* @__PURE__ */ new Map(), index);
        for (const [key, index2] of value)
          map.set(unpair(key), unpair(index2));
        return map;
      }
      case SET: {
        const set = as(/* @__PURE__ */ new Set(), index);
        for (const index2 of value)
          set.add(unpair(index2));
        return set;
      }
      case ERROR: {
        const { name, message } = value;
        return as(new env[name](message), index);
      }
      case BIGINT:
        return as(BigInt(value), index);
      case "BigInt":
        return as(Object(BigInt(value)), index);
      case "ArrayBuffer":
        return as(new Uint8Array(value).buffer, value);
      case "DataView": {
        const { buffer } = new Uint8Array(value);
        return as(new DataView(buffer), value);
      }
    }
    return as(new env[type](value), index);
  };
  return unpair;
};
var deserialize = (serialized) => deserializer(/* @__PURE__ */ new Map(), serialized)(0);

// ../../node_modules/@ungap/structured-clone/esm/serialize.js
var EMPTY = "";
var { toString } = {};
var { keys } = Object;
var typeOf = (value) => {
  const type = typeof value;
  if (type !== "object" || !value)
    return [PRIMITIVE, type];
  const asString = toString.call(value).slice(8, -1);
  switch (asString) {
    case "Array":
      return [ARRAY, EMPTY];
    case "Object":
      return [OBJECT, EMPTY];
    case "Date":
      return [DATE, EMPTY];
    case "RegExp":
      return [REGEXP, EMPTY];
    case "Map":
      return [MAP, EMPTY];
    case "Set":
      return [SET, EMPTY];
    case "DataView":
      return [ARRAY, asString];
  }
  if (asString.includes("Array"))
    return [ARRAY, asString];
  if (asString.includes("Error"))
    return [ERROR, asString];
  return [OBJECT, asString];
};
var shouldSkip = ([TYPE, type]) => TYPE === PRIMITIVE && (type === "function" || type === "symbol");
var serializer = (strict, json, $, _) => {
  const as = (out, value) => {
    const index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };
  const pair = (value) => {
    if ($.has(value))
      return $.get(value);
    let [TYPE, type] = typeOf(value);
    switch (TYPE) {
      case PRIMITIVE: {
        let entry = value;
        switch (type) {
          case "bigint":
            TYPE = BIGINT;
            entry = value.toString();
            break;
          case "function":
          case "symbol":
            if (strict)
              throw new TypeError("unable to serialize " + type);
            entry = null;
            break;
          case "undefined":
            return as([VOID], value);
        }
        return as([TYPE, entry], value);
      }
      case ARRAY: {
        if (type) {
          let spread = value;
          if (type === "DataView") {
            spread = new Uint8Array(value.buffer);
          } else if (type === "ArrayBuffer") {
            spread = new Uint8Array(value);
          }
          return as([type, [...spread]], value);
        }
        const arr = [];
        const index = as([TYPE, arr], value);
        for (const entry of value)
          arr.push(pair(entry));
        return index;
      }
      case OBJECT: {
        if (type) {
          switch (type) {
            case "BigInt":
              return as([type, value.toString()], value);
            case "Boolean":
            case "Number":
            case "String":
              return as([type, value.valueOf()], value);
          }
        }
        if (json && "toJSON" in value)
          return pair(value.toJSON());
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const key of keys(value)) {
          if (strict || !shouldSkip(typeOf(value[key])))
            entries.push([pair(key), pair(value[key])]);
        }
        return index;
      }
      case DATE:
        return as([TYPE, value.toISOString()], value);
      case REGEXP: {
        const { source, flags } = value;
        return as([TYPE, { source, flags }], value);
      }
      case MAP: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const [key, entry] of value) {
          if (strict || !(shouldSkip(typeOf(key)) || shouldSkip(typeOf(entry))))
            entries.push([pair(key), pair(entry)]);
        }
        return index;
      }
      case SET: {
        const entries = [];
        const index = as([TYPE, entries], value);
        for (const entry of value) {
          if (strict || !shouldSkip(typeOf(entry)))
            entries.push(pair(entry));
        }
        return index;
      }
    }
    const { message } = value;
    return as([TYPE, { name: type, message }], value);
  };
  return pair;
};
var serialize = (value, { json, lossy } = {}) => {
  const _ = [];
  return serializer(!(json || lossy), !!json, /* @__PURE__ */ new Map(), _)(value), _;
};

// ../../node_modules/@ungap/structured-clone/esm/index.js
var esm_default = typeof structuredClone === "function" ? (
  /* c8 ignore start */
  (any, options) => options && ("json" in options || "lossy" in options) ? deserialize(serialize(any, options)) : structuredClone(any)
) : (any, options) => deserialize(serialize(any, options));

// ../../node_modules/unist-util-position/lib/index.js
var pointEnd = point("end");
var pointStart = point("start");
function point(type) {
  return point2;
  function point2(node) {
    const point3 = node && node.position && node.position[type] || {};
    if (typeof point3.line === "number" && point3.line > 0 && typeof point3.column === "number" && point3.column > 0) {
      return {
        line: point3.line,
        column: point3.column,
        offset: typeof point3.offset === "number" && point3.offset > -1 ? point3.offset : void 0
      };
    }
  }
}
function position(node) {
  const start = pointStart(node);
  const end = pointEnd(node);
  if (start && end) {
    return { start, end };
  }
}

// ../../node_modules/hast-util-sanitize/lib/schema.js
var aria = ["ariaDescribedBy", "ariaLabel", "ariaLabelledBy"];
var defaultSchema = {
  ancestors: {
    tbody: ["table"],
    td: ["table"],
    th: ["table"],
    thead: ["table"],
    tfoot: ["table"],
    tr: ["table"]
  },
  attributes: {
    a: [
      ...aria,
      // Note: these 3 are used by GFM footnotes, they do work on all links.
      "dataFootnoteBackref",
      "dataFootnoteRef",
      ["className", "data-footnote-backref"],
      "href"
    ],
    blockquote: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `code` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    code: [["className", /^language-./]],
    del: ["cite"],
    div: ["itemScope", "itemType"],
    dl: [...aria],
    // Note: this is used by GFM footnotes.
    h2: [["className", "sr-only"]],
    img: [...aria, "longDesc", "src"],
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    input: [
      ["disabled", true],
      ["type", "checkbox"]
    ],
    ins: ["cite"],
    // Note: this class is not normally allowed by GH, when manually writing
    // `li` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    li: [["className", "task-list-item"]],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ol: [...aria, ["className", "contains-task-list"]],
    q: ["cite"],
    section: ["dataFootnotes", ["className", "footnotes"]],
    source: ["srcSet"],
    summary: [...aria],
    table: [...aria],
    // Note: this class is not normally allowed by GH, when manually writing
    // `ol` as HTML in markdown, they adds it some other way.
    // We can’t do that, so we have to allow it.
    ul: [...aria, ["className", "contains-task-list"]],
    "*": [
      "abbr",
      "accept",
      "acceptCharset",
      "accessKey",
      "action",
      "align",
      "alt",
      "axis",
      "border",
      "cellPadding",
      "cellSpacing",
      "char",
      "charOff",
      "charSet",
      "checked",
      "clear",
      "colSpan",
      "color",
      "cols",
      "compact",
      "coords",
      "dateTime",
      "dir",
      // Note: `disabled` is technically allowed on all elements by GH.
      // But it is useless on everything except `input`.
      // Because `input`s are normally not allowed, but we allow them for
      // checkboxes due to tasklists, we allow `disabled` only there.
      "encType",
      "frame",
      "hSpace",
      "headers",
      "height",
      "hrefLang",
      "htmlFor",
      "id",
      "isMap",
      "itemProp",
      "label",
      "lang",
      "maxLength",
      "media",
      "method",
      "multiple",
      "name",
      "noHref",
      "noShade",
      "noWrap",
      "open",
      "prompt",
      "readOnly",
      "rev",
      "rowSpan",
      "rows",
      "rules",
      "scope",
      "selected",
      "shape",
      "size",
      "span",
      "start",
      "summary",
      "tabIndex",
      "title",
      "useMap",
      "vAlign",
      "value",
      "width"
    ]
  },
  clobber: ["ariaDescribedBy", "ariaLabelledBy", "id", "name"],
  clobberPrefix: "user-content-",
  protocols: {
    cite: ["http", "https"],
    href: ["http", "https", "irc", "ircs", "mailto", "xmpp"],
    longDesc: ["http", "https"],
    src: ["http", "https"]
  },
  required: {
    input: { disabled: true, type: "checkbox" }
  },
  strip: ["script"],
  tagNames: [
    "a",
    "b",
    "blockquote",
    "br",
    "code",
    "dd",
    "del",
    "details",
    "div",
    "dl",
    "dt",
    "em",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "img",
    // Note: `input` is not normally allowed by GH, when manually writing
    // it in markdown, they add it from tasklists some other way.
    // We can’t do that, so we have to allow it.
    "input",
    "ins",
    "kbd",
    "li",
    "ol",
    "p",
    "picture",
    "pre",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "section",
    "source",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "tt",
    "ul",
    "var"
  ]
};

// ../../node_modules/hast-util-sanitize/lib/index.js
var own = {}.hasOwnProperty;
function sanitize(node, options) {
  let result = { type: "root", children: [] };
  const state = {
    schema: options ? { ...defaultSchema, ...options } : defaultSchema,
    stack: []
  };
  const replace = transform(state, node);
  if (replace) {
    if (Array.isArray(replace)) {
      if (replace.length === 1) {
        result = replace[0];
      } else {
        result.children = replace;
      }
    } else {
      result = replace;
    }
  }
  return result;
}
function transform(state, node) {
  if (node && typeof node === "object") {
    const unsafe = (
      /** @type {Record<string, Readonly<unknown>>} */
      node
    );
    const type = typeof unsafe.type === "string" ? unsafe.type : "";
    switch (type) {
      case "comment": {
        return comment(state, unsafe);
      }
      case "doctype": {
        return doctype(state, unsafe);
      }
      case "element": {
        return element(state, unsafe);
      }
      case "root": {
        return root(state, unsafe);
      }
      case "text": {
        return text(state, unsafe);
      }
      default:
    }
  }
}
function comment(state, unsafe) {
  if (state.schema.allowComments) {
    const result = typeof unsafe.value === "string" ? unsafe.value : "";
    const index = result.indexOf("-->");
    const value = index < 0 ? result : result.slice(0, index);
    const node = { type: "comment", value };
    patch(node, unsafe);
    return node;
  }
}
function doctype(state, unsafe) {
  if (state.schema.allowDoctypes) {
    const node = { type: "doctype" };
    patch(node, unsafe);
    return node;
  }
}
function element(state, unsafe) {
  const name = typeof unsafe.tagName === "string" ? unsafe.tagName : "";
  state.stack.push(name);
  const content = (
    /** @type {Array<ElementContent>} */
    children(state, unsafe.children)
  );
  const properties_ = properties(state, unsafe.properties);
  state.stack.pop();
  let safeElement = false;
  if (name && name !== "*" && (!state.schema.tagNames || state.schema.tagNames.includes(name))) {
    safeElement = true;
    if (state.schema.ancestors && own.call(state.schema.ancestors, name)) {
      const ancestors = state.schema.ancestors[name];
      let index = -1;
      safeElement = false;
      while (++index < ancestors.length) {
        if (state.stack.includes(ancestors[index])) {
          safeElement = true;
        }
      }
    }
  }
  if (!safeElement) {
    return state.schema.strip && !state.schema.strip.includes(name) ? content : void 0;
  }
  const node = {
    type: "element",
    tagName: name,
    properties: properties_,
    children: content
  };
  patch(node, unsafe);
  return node;
}
function root(state, unsafe) {
  const content = (
    /** @type {Array<RootContent>} */
    children(state, unsafe.children)
  );
  const node = { type: "root", children: content };
  patch(node, unsafe);
  return node;
}
function text(_, unsafe) {
  const value = typeof unsafe.value === "string" ? unsafe.value : "";
  const node = { type: "text", value };
  patch(node, unsafe);
  return node;
}
function children(state, children2) {
  const results = [];
  if (Array.isArray(children2)) {
    const childrenUnknown = (
      /** @type {Array<Readonly<unknown>>} */
      children2
    );
    let index = -1;
    while (++index < childrenUnknown.length) {
      const value = transform(state, childrenUnknown[index]);
      if (value) {
        if (Array.isArray(value)) {
          results.push(...value);
        } else {
          results.push(value);
        }
      }
    }
  }
  return results;
}
function properties(state, properties2) {
  const tagName = state.stack[state.stack.length - 1];
  const attributes = state.schema.attributes;
  const required = state.schema.required;
  const specific = attributes && own.call(attributes, tagName) ? attributes[tagName] : void 0;
  const defaults = attributes && own.call(attributes, "*") ? attributes["*"] : void 0;
  const properties_ = (
    /** @type {Readonly<Record<string, Readonly<unknown>>>} */
    properties2 && typeof properties2 === "object" ? properties2 : {}
  );
  const result = {};
  let key;
  for (key in properties_) {
    if (own.call(properties_, key)) {
      const unsafe = properties_[key];
      let safe = propertyValue(
        state,
        findDefinition(specific, key),
        key,
        unsafe
      );
      if (safe === null || safe === void 0) {
        safe = propertyValue(state, findDefinition(defaults, key), key, unsafe);
      }
      if (safe !== null && safe !== void 0) {
        result[key] = safe;
      }
    }
  }
  if (required && own.call(required, tagName)) {
    const properties3 = required[tagName];
    for (key in properties3) {
      if (own.call(properties3, key) && !own.call(result, key)) {
        result[key] = properties3[key];
      }
    }
  }
  return result;
}
function propertyValue(state, definition, key, value) {
  return definition ? Array.isArray(value) ? propertyValueMany(state, definition, key, value) : propertyValuePrimitive(state, definition, key, value) : void 0;
}
function propertyValueMany(state, definition, key, values) {
  let index = -1;
  const result = [];
  while (++index < values.length) {
    const value = propertyValuePrimitive(state, definition, key, values[index]);
    if (typeof value === "number" || typeof value === "string") {
      result.push(value);
    }
  }
  return result;
}
function propertyValuePrimitive(state, definition, key, value) {
  if (typeof value !== "boolean" && typeof value !== "number" && typeof value !== "string") {
    return;
  }
  if (!safeProtocol(state, key, value)) {
    return;
  }
  if (typeof definition === "object" && definition.length > 1) {
    let ok = false;
    let index = 0;
    while (++index < definition.length) {
      const allowed = definition[index];
      if (allowed && typeof allowed === "object" && "flags" in allowed) {
        if (allowed.test(String(value))) {
          ok = true;
          break;
        }
      } else if (allowed === value) {
        ok = true;
        break;
      }
    }
    if (!ok)
      return;
  }
  return state.schema.clobber && state.schema.clobberPrefix && state.schema.clobber.includes(key) ? state.schema.clobberPrefix + value : value;
}
function safeProtocol(state, key, value) {
  const protocols = state.schema.protocols && own.call(state.schema.protocols, key) ? state.schema.protocols[key] : void 0;
  if (!protocols || protocols.length === 0) {
    return true;
  }
  const url = String(value);
  const colon = url.indexOf(":");
  const questionMark = url.indexOf("?");
  const numberSign = url.indexOf("#");
  const slash = url.indexOf("/");
  if (colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
  slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign) {
    return true;
  }
  let index = -1;
  while (++index < protocols.length) {
    const protocol = protocols[index];
    if (colon === protocol.length && url.slice(0, protocol.length) === protocol) {
      return true;
    }
  }
  return false;
}
function patch(node, unsafe) {
  const cleanPosition = position(
    // @ts-expect-error: looks like a node.
    unsafe
  );
  if (unsafe.data) {
    node.data = esm_default(unsafe.data);
  }
  if (cleanPosition)
    node.position = cleanPosition;
}
function findDefinition(definitions, key) {
  let dataDefault;
  let index = -1;
  if (definitions) {
    while (++index < definitions.length) {
      const entry = definitions[index];
      const name = typeof entry === "string" ? entry : entry[0];
      if (name === key) {
        return entry;
      }
      if (name === "data*")
        dataDefault = entry;
    }
  }
  if (key.length > 4 && key.slice(0, 4).toLowerCase() === "data") {
    return dataDefault;
  }
}

// ../../node_modules/rehype-sanitize/lib/index.js
function rehypeSanitize(options) {
  return function(tree) {
    const result = (
      /** @type {Root} */
      sanitize(tree, options)
    );
    return result;
  };
}

// src/MarkdownRenderer/MarkdownRenderer.tsx
var import_classnames = __toESM(require_classnames(), 1);

// src/MarkdownRenderer/preprocessing.ts
var preprocessBulletPoints = (text2) => {
  return text2.replace(/^(\s*)•\s+/gm, "$1- ");
};
var preprocessEmojiLists = (text2) => {
  return text2.replace(/^(\s*)(?:✅|✓|⭐|🔹|▪️|◾|➡️|📌|🎯)\s*/gmu, "$1- ");
};
var ensureBlankLinesBeforeLists = (text2) => {
  const lines = text2.split("\n");
  const result = [];
  for (let i = 0; i < lines.length; i++) {
    const currentLine = lines[i];
    const prevLine = i > 0 ? lines[i - 1] : "";
    const isListItem = /^\s*(\d+\.|-|\*)\s+/.test(currentLine);
    const prevLineNotBlank = prevLine.trim() !== "";
    const prevIsListItem = /^\s*(\d+\.|-|\*)\s+/.test(prevLine);
    if (isListItem && prevLineNotBlank && !prevIsListItem) {
      result.push("");
    }
    result.push(currentLine);
  }
  return result.join("\n");
};
var preprocessMarkdown = (text2) => {
  let processed = text2;
  processed = preprocessBulletPoints(processed);
  processed = preprocessEmojiLists(processed);
  processed = ensureBlankLinesBeforeLists(processed);
  return processed;
};

// src/MarkdownRenderer/components.tsx
import * as React from "react";
import Box2 from "@cloudscape-design/components/box";
import CopyToClipboard from "@cloudscape-design/components/copy-to-clipboard";
import Header from "@cloudscape-design/components/header";
import Link from "@cloudscape-design/components/link";
import Table from "@cloudscape-design/components/table";
import TextContent from "@cloudscape-design/components/text-content";

// node_modules/@cloudscape-design/code-view/code-view/index.js
import { jsx as _jsx2 } from "react/jsx-runtime";

// node_modules/@cloudscape-design/code-view/internal/base-component/apply-display-name.js
function applyDisplayName(component, displayName) {
  component.displayName = displayName;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metadata.js
import { useEffect, useRef } from "react";
var COMPONENT_METADATA_KEY = "__awsuiMetadata__";
function useComponentMetadata(componentName, packageMetadata, analyticsMetadata) {
  const elementRef = useRef(null);
  useEffect(() => {
    if (elementRef.current) {
      const pkgMetadata = typeof packageMetadata === "string" ? { version: packageMetadata } : packageMetadata;
      const node = elementRef.current;
      const metadata = {
        ...pkgMetadata,
        name: componentName
      };
      if (analyticsMetadata && Object.keys(analyticsMetadata).length > 0) {
        metadata.analytics = analyticsMetadata;
      }
      Object.freeze(metadata);
      Object.defineProperty(node, COMPONENT_METADATA_KEY, { value: metadata, writable: false, configurable: true });
    }
  });
  return elementRef;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metrics.js
import { useEffect as useEffect2 } from "react";

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/log-clients.js
var AWSUI_EVENT = "awsui";
function validateLength(value, maxLength) {
  return !value || value.length <= maxLength;
}
var CLogClient = class {
  /**
   * Sends metric but only if Console Platform client logging JS API is present in the page.
   */
  sendMetric(metricName, value, detail) {
    if (!metricName || !/^[a-zA-Z0-9_-]+$/.test(metricName)) {
      console.error(`Invalid metric name: ${metricName}`);
      return;
    }
    if (!validateLength(metricName, 1e3)) {
      console.error(`Metric name ${metricName} is too long`);
      return;
    }
    if (!validateLength(detail, 4e3)) {
      console.error(`Detail for metric ${metricName} is too long: ${detail}`);
      return;
    }
    const wasSent = new PanoramaClient().sendMetric({
      eventContext: metricName,
      eventDetail: detail,
      eventValue: `${value}`,
      timestamp: Date.now()
    });
    if (wasSent) {
      return;
    }
    const AWSC = this.findAWSC(window);
    if (typeof AWSC === "object" && typeof AWSC.Clog === "object" && typeof AWSC.Clog.log === "function") {
      AWSC.Clog.log(metricName, value, detail);
    }
  }
  findAWSC(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC) === "object") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.AWSC;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findAWSC(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};
var PanoramaClient = class {
  /**
   * Sends metric but only if Console Platform client v2 logging JS API is present in the page.
   */
  sendMetric(metric) {
    const panorama = this.findPanorama(window);
    if (!panorama) {
      return false;
    }
    const payload = {
      eventType: AWSUI_EVENT,
      timestamp: Date.now(),
      ...metric,
      eventDetail: typeof metric.eventDetail === "object" ? JSON.stringify(metric.eventDetail) : metric.eventDetail,
      eventValue: typeof metric.eventValue === "object" ? JSON.stringify(metric.eventValue) : metric.eventValue
    };
    if (!validateLength(payload.eventDetail, 4e3)) {
      this.onMetricError(`Event detail for metric is too long: ${payload.eventDetail}`);
      return true;
    }
    if (!validateLength(payload.eventValue, 4e3)) {
      this.onMetricError(`Event value for metric is too long: ${payload.eventValue}`);
      return true;
    }
    if (!validateLength(payload.eventContext, 4e3)) {
      this.onMetricError(`Event context for metric is too long: ${payload.eventContext}`);
      return true;
    }
    panorama("trackCustomEvent", payload);
    return true;
  }
  onMetricError(message) {
    console.error(message);
    const panorama = this.findPanorama(window);
    if (panorama) {
      panorama("trackCustomEvent", {
        eventType: AWSUI_EVENT,
        eventContext: "awsui-metric-error",
        eventDetail: message.slice(0, 4e3),
        timestamp: Date.now()
      });
    }
  }
  findPanorama(currentWindow) {
    try {
      if (typeof (currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama) === "function") {
        return currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow.panorama;
      }
      const panoramaSymbol = Symbol.for("panorama");
      const symbolProperty = currentWindow === null || currentWindow === void 0 ? void 0 : currentWindow[panoramaSymbol];
      if (typeof symbolProperty === "function") {
        return symbolProperty;
      }
      if (!currentWindow || currentWindow.parent === currentWindow) {
        return void 0;
      }
      return this.findPanorama(currentWindow.parent);
    } catch {
      return void 0;
    }
  }
};

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/formatters.js
function buildMetricDetail(detail, context) {
  const metricOrigin = typeof AWSUI_METRIC_ORIGIN !== "undefined" ? AWSUI_METRIC_ORIGIN : "main";
  const detailObject = {
    o: metricOrigin,
    t: context.theme,
    // React is the only framework we're using.
    f: "react",
    // Remove spaces from the version string for compactness
    v: context.packageVersion.replace(/\s/g, ""),
    ...detail
  };
  return jsonStringify(detailObject);
}
function buildComponentMetricDetail({ componentName, action, configuration, packageSource }, context) {
  return buildMetricDetail({
    a: action,
    s: componentName,
    p: packageSource,
    c: configuration
  }, context);
}
function jsonStringify(detailObject) {
  return JSON.stringify(detailObject, detailSerializer);
}
function detailSerializer(key, value) {
  if (typeof value === "number" && !Number.isFinite(value)) {
    return `${value}`;
  }
  return value;
}
function getMajorVersion(versionString) {
  const majorVersionMatch = versionString.match(/^(\d+\.\d+)/);
  return majorVersionMatch ? majorVersionMatch[1].replace(".", "") : "";
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/metrics/metrics.js
var oneTimeMetrics = /* @__PURE__ */ new Set();
var Metrics = class {
  constructor(...args) {
    this.clog = new CLogClient();
    this.panorama = new PanoramaClient();
    if (args.length === 1) {
      this.context = args[0];
    } else {
      const [packageSource, packageVersion] = args;
      this.context = { packageSource, packageVersion, theme: "unknown" };
    }
  }
  sendComponentMetric(metric) {
    this.sendMetricOnce(`awsui_${metric.componentName}_${this.context.theme.charAt(0)}${getMajorVersion(this.context.packageVersion)}`, 1, buildComponentMetricDetail(metric, this.context));
  }
  /*
   * Calls Console Platform's client logging only the first time the provided metricName is used.
   * Subsequent calls with the same metricName are ignored.
   */
  sendMetricOnce(metricName, value, detail) {
    const key = [metricName + value + detail].join("|");
    if (!oneTimeMetrics.has(key)) {
      this.clog.sendMetric(metricName, value, detail);
      oneTimeMetrics.add(key);
    }
  }
  /**
   * Calls Console Platform's client v2 logging JS API with provided metric name and detail.
   * Does nothing if Console Platform client logging JS is not present in page.
   */
  sendPanoramaMetric(metric) {
    this.panorama.sendMetric(metric);
  }
  sendOpsMetricObject(metricName, detail) {
    this.sendMetricOnce(metricName, 1, buildMetricDetail(detail, this.context));
  }
  sendOpsMetricValue(metricName, value) {
    this.sendMetricOnce(metricName, value);
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was loaded. The component load event will only be reported as used to client logging
   * service once per page view.
   */
  logComponentsLoaded() {
    this.sendComponentMetric({ componentName: this.context.packageSource, action: "loaded" });
  }
  /*
   * Reports a metric value 1 to Console Platform's client logging service to indicate that the
   * component was used in the page.  A component will only be reported as used to client logging
   * service once per page view.
   */
  logComponentUsed(componentName, configuration) {
    this.sendComponentMetric({
      action: "used",
      componentName,
      configuration,
      packageSource: this.context.packageSource
    });
  }
};

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/component-metrics.js
function useComponentMetrics(componentName, settings, configuration = { props: {} }) {
  useEffect2(() => {
    const metrics = new Metrics(settings);
    if (typeof window !== "undefined") {
      metrics.sendOpsMetricValue("awsui-viewport-width", window.innerWidth || 0);
      metrics.sendOpsMetricValue("awsui-viewport-height", window.innerHeight || 0);
    }
    metrics.logComponentsLoaded();
    metrics.logComponentUsed(componentName.toLowerCase(), configuration);
  }, []);
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/base-component/init-awsui-versions.js
function initAwsUiVersions(source, packageVersion) {
  if (typeof window !== "undefined") {
    if (!window.awsuiVersions) {
      window.awsuiVersions = {};
    }
    if (!window.awsuiVersions[source]) {
      window.awsuiVersions[source] = [];
    }
    window.awsuiVersions[source].push(packageVersion);
  }
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/stable-callback/index.js
import { useCallback, useEffect as useEffect3, useRef as useRef2 } from "react";
function useStableCallback(fn) {
  const ref = useRef2();
  useEffect3(() => {
    ref.current = fn;
  });
  return useCallback((...args) => {
    var _a;
    return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.call(ref, ...args);
  }, []);
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/singleton-handler/index.js
import { useEffect as useEffect4, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";
function createSingletonHandler(factory) {
  const listeners = [];
  const callback = (value) => {
    unstable_batchedUpdates(() => {
      for (const listener of listeners) {
        listener(value);
      }
    });
  };
  let cleanup;
  return function useSingleton(listener) {
    useEffect4(() => {
      if (listeners.length === 0) {
        cleanup = factory(callback);
      }
      listeners.push(listener);
      return () => {
        listeners.splice(listeners.indexOf(listener), 1);
        if (listeners.length === 0) {
          cleanup();
          cleanup = void 0;
        }
      };
    }, []);
  };
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/visual-mode/index.js
import { useEffect as useEffect5, useState as useState2 } from "react";

// ../../node_modules/@cloudscape-design/component-toolkit/dom/element-types.js
function isNode(target) {
  return target instanceof Node || target !== null && typeof target === "object" && "nodeType" in target && typeof target.nodeType === "number" && "nodeName" in target && typeof target.nodeName === "string" && "parentNode" in target && typeof target.parentNode === "object";
}
function isHTMLElement(target) {
  return target instanceof HTMLElement || isNode(target) && target.nodeType === Node.ELEMENT_NODE && "style" in target && typeof target.style === "object" && typeof target.ownerDocument === "object" && !isSVGElement(target);
}
function isSVGElement(target) {
  return target instanceof SVGElement || isNode(target) && target.nodeType === Node.ELEMENT_NODE && "ownerSVGElement" in target && typeof target.ownerSVGElement === "object";
}

// ../../node_modules/@cloudscape-design/component-toolkit/dom/find-up-until.js
function findUpUntil(from, test) {
  let current = from;
  while (current && !test(current)) {
    current = current.parentElement;
    while (current && !isHTMLElement(current)) {
      current = current.parentElement;
    }
  }
  return current;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/is-development.js
var isDevelopment = true;

// ../../node_modules/@cloudscape-design/component-toolkit/internal/logging.js
var messageCache = /* @__PURE__ */ new Set();
function warnOnce(component, message) {
  if (isDevelopment) {
    const warning = `[AwsUi] [${component}] ${message}`;
    if (!messageCache.has(warning)) {
      messageCache.add(warning);
      console.warn(warning);
    }
  }
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/global-flags/index.js
var awsuiVisualRefreshFlag = Symbol.for("awsui-visual-refresh-flag");
var awsuiGlobalFlagsSymbol = Symbol.for("awsui-global-flags");
function getGlobal() {
  return typeof window !== "undefined" ? window : globalThis;
}

// ../../node_modules/@cloudscape-design/component-toolkit/internal/visual-mode/index.js
function useModeDetector(elementRef, detector, initialValue) {
  const [value, setValue] = useState2(initialValue);
  useMutationObserver(elementRef, (node) => {
    const newValue = detector(node);
    if (newValue !== value) {
      setValue(newValue);
    }
  });
  return value;
}
function detectCurrentMode(node) {
  const darkModeParent = findUpUntil(node, (node2) => node2.classList.contains("awsui-polaris-dark-mode") || node2.classList.contains("awsui-dark-mode"));
  return darkModeParent ? "dark" : "light";
}
function useCurrentMode(elementRef) {
  return useModeDetector(elementRef, detectCurrentMode, "light");
}
var useMutationSingleton = createSingletonHandler((handler) => {
  const observer = new MutationObserver(() => handler());
  observer.observe(document.body, { attributes: true, subtree: true });
  return () => observer.disconnect();
});
function useMutationObserver(elementRef, onChange) {
  const handler = useStableCallback(() => {
    if (elementRef.current) {
      onChange(elementRef.current);
    }
  });
  useMutationSingleton(handler);
  useEffect5(() => {
    handler();
  }, [handler]);
}
var visualRefreshState = void 0;
function detectVisualRefreshClassName() {
  return typeof document !== "undefined" && !!document.querySelector(".awsui-visual-refresh");
}
function detectVisualRefreshFlag() {
  var _a, _b;
  const global = getGlobal();
  return (_b = (_a = global === null || global === void 0 ? void 0 : global[awsuiVisualRefreshFlag]) === null || _a === void 0 ? void 0 : _a.call(global)) !== null && _b !== void 0 ? _b : false;
}
function useRuntimeVisualRefresh() {
  if (visualRefreshState === void 0) {
    visualRefreshState = detectVisualRefreshClassName();
    if (!visualRefreshState) {
      if (detectVisualRefreshFlag()) {
        visualRefreshState = true;
        if (typeof document !== "undefined") {
          document.body.classList.add("awsui-visual-refresh");
        }
      }
    }
  }
  if (isDevelopment) {
    const newVisualRefreshState = detectVisualRefreshClassName() || detectVisualRefreshFlag();
    if (newVisualRefreshState !== visualRefreshState) {
      warnOnce("Visual Refresh", "Dynamic visual refresh change detected. This is not supported. Make sure `awsui-visual-refresh` is attached to the `<body>` element before initial React render");
    }
  }
  return visualRefreshState;
}

// node_modules/@cloudscape-design/code-view/internal/environment.js
var PACKAGE_SOURCE = "code-view";
var PACKAGE_VERSION = "3.0.0 (ac787dd8)";
var THEME = "open-source-visual-refresh";
var ALWAYS_VISUAL_REFRESH = true;

// node_modules/@cloudscape-design/code-view/internal/utils/get-visual-theme.js
var getVisualTheme = (theme, isVR) => {
  if (theme === "polaris" && isVR) {
    return "vr";
  }
  return theme;
};

// node_modules/@cloudscape-design/code-view/internal/base-component/use-visual-refresh.js
var useVisualRefresh = ALWAYS_VISUAL_REFRESH ? () => true : useRuntimeVisualRefresh;

// node_modules/@cloudscape-design/code-view/internal/base-component/use-telemetry.js
function useTelemetry(componentName, config) {
  const isVisualRefresh = useVisualRefresh();
  const theme = getVisualTheme(THEME, isVisualRefresh);
  useComponentMetrics(componentName, { packageSource: PACKAGE_SOURCE, packageVersion: PACKAGE_VERSION, theme }, config);
}

// node_modules/@cloudscape-design/code-view/internal/base-component/use-base-component.js
initAwsUiVersions(PACKAGE_SOURCE, PACKAGE_VERSION);
function useBaseComponent(componentName, config) {
  useTelemetry(componentName, config);
  const isVisualRefresh = useVisualRefresh();
  const theme = getVisualTheme(THEME, isVisualRefresh);
  const elementRef = useComponentMetadata(componentName, {
    packageName: PACKAGE_SOURCE,
    version: PACKAGE_VERSION,
    theme
  });
  return { __internalRootRef: elementRef };
}
function getBaseProps(props) {
  const baseProps = {};
  Object.keys(props).forEach((prop) => {
    if (prop.startsWith("data-")) {
      baseProps[prop] = props[prop];
    }
  });
  return baseProps;
}

// node_modules/@cloudscape-design/code-view/code-view/internal.js
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Children, createElement, Fragment, useMemo, useRef as useRef3 } from "react";

// ../../node_modules/clsx/dist/clsx.m.js
function r(e) {
  var t, f, n = "";
  if ("string" == typeof e || "number" == typeof e)
    n += e;
  else if ("object" == typeof e)
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    else
      for (t in e)
        e[t] && (n && (n += " "), n += t);
  return n;
}
function clsx() {
  for (var e, t, f = 0, n = ""; f < arguments.length; )
    (e = arguments[f++]) && (t = r(e)) && (n && (n += " "), n += t);
  return n;
}
var clsx_m_default = clsx;

// node_modules/@cloudscape-design/code-view/code-view/internal.js
import Box from "@cloudscape-design/components/box";

// node_modules/@cloudscape-design/code-view/code-view/styles.css.js
var styles_css_default = {
  "root": "awsui_root_1pkji_5uci6_5",
  "scroll-container": "awsui_scroll-container_1pkji_5uci6_14",
  "code-table": "awsui_code-table_1pkji_5uci6_18",
  "code-table-with-actions": "awsui_code-table-with-actions_1pkji_5uci6_25",
  "screenreader-only": "awsui_screenreader-only_1pkji_5uci6_30",
  "line-number": "awsui_line-number_1pkji_5uci6_36",
  "unselectable": "awsui_unselectable_1pkji_5uci6_48",
  "code-line": "awsui_code-line_1pkji_5uci6_53",
  "code-line-wrap": "awsui_code-line-wrap_1pkji_5uci6_57",
  "code-line-nowrap": "awsui_code-line-nowrap_1pkji_5uci6_61",
  "code-table-with-line-wrapping": "awsui_code-table-with-line-wrapping_1pkji_5uci6_65",
  "actions": "awsui_actions_1pkji_5uci6_73"
};

// node_modules/@cloudscape-design/code-view/code-view/internal.js
var ACE_CLASSES = { light: "ace-cloud_editor", dark: "ace-cloud_editor_dark" };
var REGION_PROPS = { role: "region" };
var NO_REGION_PROPS = {};
var textHighlight = (code) => {
  const lines = code.split("\n");
  return _jsx("span", { children: lines.map((line, lineIndex) => _jsxs("span", { children: [line, lineIndex < lines.length - 1 ? "\n" : ""] }, lineIndex)) });
};
function InternalCodeView({ content, actions, lineNumbers, wrapLines, highlight, ariaLabel, ariaLabelledby, i18nStrings, __internalRootRef = null, ...props }) {
  const baseProps = getBaseProps(props);
  const containerRef = useRef3(null);
  const darkMode = useCurrentMode(containerRef) === "dark";
  const regionProps = ariaLabel || ariaLabelledby ? REGION_PROPS : NO_REGION_PROPS;
  const accessibleLineNumbers = lineNumbers && (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.lineNumberLabel) && (i18nStrings === null || i18nStrings === void 0 ? void 0 : i18nStrings.codeLabel);
  const code = useMemo(() => highlight ? highlight(content) : textHighlight(content), [content, highlight]);
  const codeElementWrapper = createElement(Fragment, null, code);
  const codeElement = Children.only(codeElementWrapper.props.children);
  return _jsxs("div", { className: clsx_m_default(darkMode ? ACE_CLASSES.dark : ACE_CLASSES.light, styles_css_default.root), ...regionProps, ...baseProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledby, dir: "ltr", ref: __internalRootRef, children: [_jsx("div", { className: styles_css_default["scroll-container"], ref: containerRef, children: _jsxs("table", { role: !accessibleLineNumbers ? "presentation" : void 0, className: clsx_m_default(styles_css_default["code-table"], actions && styles_css_default["code-table-with-actions"], wrapLines && styles_css_default["code-table-with-line-wrapping"]), children: [_jsxs("colgroup", { children: [_jsx("col", {
    style: { width: 1 }
    /* shrink to fit content */
  }), _jsx("col", { style: { width: "auto" } })] }), accessibleLineNumbers && _jsx("thead", { className: styles_css_default["screenreader-only"], children: _jsxs("tr", { children: [lineNumbers && _jsx("th", { children: i18nStrings.lineNumberLabel }), _jsx("th", { children: i18nStrings.codeLabel })] }) }), _jsx("tbody", { children: Children.map(codeElement.props.children, (child, index) => {
    return _jsxs("tr", { children: [lineNumbers && _jsx("td", { className: clsx_m_default(styles_css_default["line-number"], styles_css_default.unselectable), "aria-hidden": !accessibleLineNumbers, children: _jsx(Box, { variant: "code", color: "text-status-inactive", fontSize: "body-m", children: index + 1 }) }), _jsx("td", { className: styles_css_default["code-line"], children: _jsx(Box, { variant: "code", fontSize: "body-m", children: _jsx("span", { className: clsx_m_default(codeElement.props.className, wrapLines ? styles_css_default["code-line-wrap"] : styles_css_default["code-line-nowrap"]), children: child }) }) })] }, index);
  }) })] }) }), actions && _jsx("div", { className: styles_css_default.actions, children: actions })] });
}

// node_modules/@cloudscape-design/code-view/code-view/index.js
function CodeView(props) {
  const baseComponentProps = useBaseComponent("CodeView", {
    props: { lineNumbers: props.lineNumbers, wrapLines: props.wrapLines },
    metadata: { hasActions: !!props.actions }
  });
  return _jsx2(InternalCodeView, { ...props, ...baseComponentProps });
}
applyDisplayName(CodeView, "CodeView");

// src/MarkdownRenderer/components.tsx
import { MessageRole } from "@amzn/awsmp-max-model";
import { useAppTranslation } from "@amzn/awsmp-max-translations";

// src/MarkdownRenderer/MarkdownRenderer.module.scss
var MarkdownRenderer_module_default = {
  user: "MarkdownRenderer_module_user",
  paragraph: "MarkdownRenderer_module_paragraph",
  link: "MarkdownRenderer_module_link",
  code: "MarkdownRenderer_module_code",
  heading1: "MarkdownRenderer_module_heading1",
  heading2: "MarkdownRenderer_module_heading2",
  heading3: "MarkdownRenderer_module_heading3",
  heading4: "MarkdownRenderer_module_heading4",
  list: "MarkdownRenderer_module_list",
  listItem: "MarkdownRenderer_module_listItem",
  blockquote: "MarkdownRenderer_module_blockquote",
  strong: "MarkdownRenderer_module_strong",
  emphasis: "MarkdownRenderer_module_emphasis"
};

// src/MarkdownRenderer/components.tsx
import { Fragment as Fragment2, jsx } from "react/jsx-runtime";
var EMPTY_CELL_PLACEHOLDER = "-";
var TABLE_SECTION_HEAD = "thead";
var TABLE_SECTION_BODY = "tbody";
var COLUMN_ID_PREFIX = "col";
var hasChildren = (props) => props !== null && typeof props === "object" && "children" in props;
var getElementChildren = (el) => {
  const props = el.props;
  if (hasChildren(props)) {
    return props.children;
  }
  return void 0;
};
var flattenCode = (children2) => React.Children.toArray(children2).map((child) => {
  if (typeof child === "string") {
    return child;
  }
  if (React.isValidElement(child)) {
    return flattenCode(getElementChildren(child));
  }
  return "";
}).join("");
var codeToString = (children2) => flattenCode(children2).replace(/\n$/, "");
var CodeBlock = ({ children: children2 }) => {
  const { t } = useAppTranslation();
  const code = codeToString(children2);
  return /* @__PURE__ */ jsx(Box2, { margin: { vertical: "xs" }, children: /* @__PURE__ */ jsx(
    CodeView,
    {
      content: code,
      lineNumbers: true,
      actions: /* @__PURE__ */ jsx(
        CopyToClipboard,
        {
          copyButtonAriaLabel: t("copyCode"),
          copyErrorText: t("copyCodeError"),
          copySuccessText: t("copyCodeSuccess"),
          textToCopy: code
        }
      )
    }
  ) });
};
var getMarkdownComponents = (config = {}) => {
  const { processChildren: processChildrenProp, variant } = config;
  const processChildren = processChildrenProp || ((children2) => children2);
  const isUserMessage = variant === MessageRole.User;
  return {
    // Map markdown elements to Cloudscape components
    p: ({ children: children2 }) => /* @__PURE__ */ jsx(TextContent, { className: MarkdownRenderer_module_default.paragraph, children: /* @__PURE__ */ jsx("div", { style: { lineHeight: "1.6" }, children: processChildren(children2) }) }),
    a: ({ href, children: children2 }) => /* @__PURE__ */ jsx(Link, { href, external: true, className: MarkdownRenderer_module_default.link, children: processChildren(children2) }),
    // `pre` wraps fenced code blocks ONLY (inline code never gets a `pre`), so it is the
    // reliable block-vs-inline discriminator — independent of whether the fence carries a
    // language tag. This also avoids nesting a block-level CodeView inside the default
    // `<pre>`. User messages render the raw code as plain text; everyone else gets a
    // copyable CodeView, so ALL fenced blocks are copyable, not just language-tagged ones.
    pre: ({ children: children2 }) => isUserMessage ? /* @__PURE__ */ jsx(Fragment2, { children: children2 }) : /* @__PURE__ */ jsx(CodeBlock, { children: children2 }),
    // Reached for inline code and the inner <code> of a fenced block. The `pre` override
    // above renders the block wrapper (CodeBlock), so this only needs to style inline code.
    // `Box variant="awsui-inline-code"` renders a <code> element with Cloudscape's own
    // inline-code background/padding (themes correctly in light/dark) — preferred over
    // hand-rolled inline styles.
    code: ({ children: children2 }) => {
      if (isUserMessage) {
        return /* @__PURE__ */ jsx(Fragment2, { children: processChildren(children2) });
      }
      return /* @__PURE__ */ jsx(Box2, { variant: "awsui-inline-code", children: processChildren(children2) });
    },
    h1: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { bottom: "s", top: "xs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h1", className: MarkdownRenderer_module_default.heading1, children: processChildren(children2) }) }),
    h2: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { bottom: "xs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h2", className: MarkdownRenderer_module_default.heading2, children: processChildren(children2) }) }),
    h3: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading3, children: processChildren(children2) }) }),
    h4: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { bottom: "xxs", top: "xxs" }, children: /* @__PURE__ */ jsx(Header, { variant: "h3", className: MarkdownRenderer_module_default.heading4, children: processChildren(children2) }) }),
    ul: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ul", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children2) }) }),
    ol: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { left: "l", vertical: "xs" }, children: /* @__PURE__ */ jsx("ol", { className: MarkdownRenderer_module_default.list, style: { paddingLeft: "20px" }, children: processChildren(children2) }) }),
    li: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { bottom: "xxs" }, children: /* @__PURE__ */ jsx("li", { className: MarkdownRenderer_module_default.listItem, children: processChildren(children2) }) }),
    blockquote: ({ children: children2 }) => /* @__PURE__ */ jsx(Box2, { margin: { left: "m", vertical: "xs" }, padding: { left: "m" }, color: "text-body-secondary", children: /* @__PURE__ */ jsx("div", { className: MarkdownRenderer_module_default.blockquote, style: { borderLeft: "2px solid #d1d5db", paddingLeft: "12px" }, children: processChildren(children2) }) }),
    hr: () => /* @__PURE__ */ jsx(Box2, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx("hr", { style: { border: "0", borderTop: "1px solid #e1e4e8" } }) }),
    strong: ({ children: children2 }) => /* @__PURE__ */ jsx("strong", { className: MarkdownRenderer_module_default.strong, children: processChildren(children2) }),
    em: ({ children: children2 }) => /* @__PURE__ */ jsx("em", { className: MarkdownRenderer_module_default.emphasis, children: processChildren(children2) }),
    table: ({ children: children2 }) => {
      const headers = [];
      const rows = [];
      React.Children.forEach(children2, (section) => {
        if (!React.isValidElement(section))
          return;
        const sectionChildren = getElementChildren(section);
        React.Children.forEach(sectionChildren, (row) => {
          if (!React.isValidElement(row))
            return;
          const rowChildren = getElementChildren(row);
          if (section.type === TABLE_SECTION_HEAD) {
            React.Children.forEach(rowChildren, (cell) => {
              if (!React.isValidElement(cell))
                return;
              const cellContent = processChildren(getElementChildren(cell));
              headers.push(cellContent);
            });
          } else if (section.type === TABLE_SECTION_BODY) {
            const rowData = {};
            let colIdx = 0;
            React.Children.forEach(rowChildren, (cell) => {
              if (!React.isValidElement(cell))
                return;
              const cellContent = processChildren(getElementChildren(cell));
              rowData[`${COLUMN_ID_PREFIX}${colIdx}`] = cellContent;
              colIdx++;
            });
            rows.push(rowData);
          }
        });
      });
      const columnDefinitions = headers.map((header, i) => ({
        id: `${COLUMN_ID_PREFIX}${i}`,
        header,
        cell: (item) => item[`${COLUMN_ID_PREFIX}${i}`] ?? EMPTY_CELL_PLACEHOLDER
      }));
      if (headers.length === 0) {
        return null;
      }
      return /* @__PURE__ */ jsx(Box2, { margin: { vertical: "m" }, children: /* @__PURE__ */ jsx(
        Table,
        {
          columnDefinitions,
          items: rows,
          enableKeyboardNavigation: true,
          sortingDisabled: true,
          variant: "borderless",
          wrapLines: true,
          resizableColumns: true,
          ariaLabels: { tableLabel: "Data table" }
        }
      ) });
    }
  };
};
var ADDITIONAL_SANITIZED_TAGS = ["thead", "tbody", "tr", "th", "td", "br"];
var getSanitizeSchema = () => ({
  tagNames: [...Object.keys(getMarkdownComponents()), ...ADDITIONAL_SANITIZED_TAGS]
});

// src/MarkdownRenderer/MarkdownRenderer.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var MarkdownRenderer = ({
  children: children2,
  processChildren,
  className,
  variant,
  allowHtml = false,
  allowSanitizedHtml = false
}) => {
  const preprocessedText = React2.useMemo(() => preprocessMarkdown(children2), [children2]);
  const components = React2.useMemo(() => getMarkdownComponents({ processChildren, variant }), [processChildren, variant]);
  const variantClass = variant ? MarkdownRenderer_module_default[variant] : void 0;
  const rehypePlugins = React2.useMemo(() => {
    if (allowSanitizedHtml) {
      return [rehypeRaw, [rehypeSanitize, getSanitizeSchema()]];
    }
    if (allowHtml) {
      return [rehypeRaw];
    }
    return [];
  }, [allowHtml, allowSanitizedHtml]);
  return /* @__PURE__ */ jsx2("div", { className: (0, import_classnames.default)(className, variantClass), children: /* @__PURE__ */ jsx2(Box3, { children: /* @__PURE__ */ jsx2(ReactMarkdown, { remarkPlugins: [remarkGfm], rehypePlugins, components, children: preprocessedText }) }) });
};
export {
  MarkdownRenderer,
  ensureBlankLinesBeforeLists,
  getMarkdownComponents,
  preprocessBulletPoints,
  preprocessEmojiLists,
  preprocessMarkdown
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/
//# sourceMappingURL=index.js.map
